import SendBird from './SendBird';

export default SendBird;
